import { render } from "./OnboardingFirebasePage.vue?vue&type=template&id=4db1b432"
import script from "./OnboardingFirebasePage.vue?vue&type=script&lang=js"
export * from "./OnboardingFirebasePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__